import { Modal } from 'antd'
import {
  UploadFile,
  UploadFileProps,
} from 'features/rightDrawer/drawerStates/uploadFiles/UploadFile'
import React from 'react'

type UploadFileModalProps = {
  open: boolean
} & UploadFileProps

export const UploadFileModal: React.FC<UploadFileModalProps> = ({
  open,
  ...uploadFileProps
}) => {
  return (
    <Modal
      open={open}
      footer={null}
      onCancel={uploadFileProps.onClose}
      title='Upload File'>
      <UploadFile {...uploadFileProps} />
    </Modal>
  )
}
